import { ReactNode, useRef } from 'react';

import { useIsOverflowing } from '@atom/hooks/useIsOverflowing';
import { Tooltip } from '@atom/mui';

import classes from './header.module.css';

type HeaderFieldProps = {
  label: string;
  value: string;
  children?: ReactNode;
};

const HeaderField = ({ label, value, children }: HeaderFieldProps) => {
  const container = useRef<HTMLDivElement>(null);
  const overflowing = useIsOverflowing(container, [value]);

  return (
    <>
      <div className={classes.headerFieldLabel}>{label}</div>
      <Tooltip title={overflowing ? value : ''}>
        <div ref={container} className={classes.headerFieldValue}>
          {children ?? value}
        </div>
      </Tooltip>
    </>
  );
};

export default HeaderField;
